import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate } from "../../hooks";
import { useSelector } from "react-redux";
import {
  validateName,
  validateEmail,
  validatePhoneNumber,
  validateFacebookUrl,
  validateLinkedInUrl,
  validateStreet,
  validateGST,
} from "../../utils/textFieldValidations";

const AdminSiteSettings = () => {
  const [siteSettings, setSiteSettings] = useState({
    logo: null,
    footerLogo: null,
    title: "",
    description: "",
    contactEmail: "",
    contactPhone: "",
    address: "",
    facebook: "",
    linkedin: "",
    gstNumber: "",
    gstCharge: "",
    platformFee: "",
    deliveryPartnerFee: "",
  });

  const initializeSiteSettings = () => {
    setSiteSettings({
      logo: null,
      footerLogo: null,
      title: "",
      description: "",
      contactEmail: "",
      contactPhone: "",
      address: "",
      facebook: "",
      linkedin: "",
      gstNumber: "",
      gstCharge: "",
      platformFee: "",
      deliveryPartnerFee: "",
    });
  };
  const loginToken = useSelector((state) => state?.user?.logintoken);
  const logoInputRef = useRef(null);
  const footerLogoInputRef = useRef(null);
  const [data, setData] = useState("");
  const [existingLogo, setExistingLogo] = useState("");
  const [existingFooterLogo, setExistingFooterLogo] = useState("");
  const [errors, setErrors] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    setSiteSettings({
      ...siteSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e, field) => {
    const file = e.target.files[0];

    if (file) {
      setSiteSettings({
        ...siteSettings,
        [field]: file,
      });

      if (field === "logo") {
        setExistingLogo(URL.createObjectURL(file));
      }

      if (field === "footerLogo") {
        setExistingFooterLogo(URL.createObjectURL(file));
      }
    }
  };

  const {
    data: siteSettingsData,
    isLoading: isSiteSettingsDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAdminSiteSettings"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateSiteSettingsData,
    isLoading: updateSiteSettingsLoading,
    error: updateSiteSettingsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (siteSettingsData?.status === true) {
      const data = siteSettingsData.data;

      setExistingLogo(data.logo);
      setExistingFooterLogo(data.footer_logo);

      setSiteSettings((prev) => ({
        ...prev,
        title: data.title || "",
        description: data.description || "",
        contactEmail: data.contact_email || "",
        contactPhone: data.contact_phone || "",
        address: data.address || "",
        facebook: data.social_links?.facebook || "",
        linkedin: data.social_links?.linkdin || "",
        gstNumber: data.gst_number || "",
        gstCharge: data.gst_charge || "",
        platformFee: data.platform_fee || "",
        deliveryPartnerFee: data.delivery_partner_fee || "",
      }));
    }
  }, [siteSettingsData]);

  const clearErrors = () => {
    setErrors({});
  };
  useEffect(() => {
    if (error) {
    } else if (siteSettingsData && siteSettingsData["status"] === true) {
      setData(siteSettingsData["data"]);
    }
  }, [siteSettingsData, error]);

  // Update Site Settings
  const submitSiteSettings = async () => {
    let validationErrors = {};

    if (!validateName(siteSettings.title)) {
      validationErrors.title =
        "Title is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!validateName(siteSettings.description)) {
      validationErrors.description =
        "Description is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!siteSettings.logo && !existingLogo) {
  validationErrors.logo = "Logo is required";
  setErrors(validationErrors);
  return;
}

    if (!siteSettings.footerLogo && !existingFooterLogo) {
      validationErrors.footerLogo = "Footer logo is required";
      setErrors(validationErrors);
      return;
    }

    if (!siteSettings.facebook) {
      validationErrors.facebook = "Facebook link is required";
      setErrors(validationErrors);
      return;
    }

    if (!validateFacebookUrl(siteSettings.facebook)) {
      validationErrors.facebook = "Enter a valid Facebook profile/page URL";
      setErrors(validationErrors);
      return;
    }

    if (!siteSettings.linkedin) {
      validationErrors.linkedin = "LinkedIn link is required";
      setErrors(validationErrors);
      return;
    }

    if (!validateLinkedInUrl(siteSettings.linkedin)) {
      validationErrors.linkedin = "Enter a valid LinkedIn profile/page URL";
      setErrors(validationErrors);
      return;
    }

    if (!validateEmail(siteSettings.contactEmail)) {
      validationErrors.contactEmail = "Please enter a valid email address.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePhoneNumber(siteSettings.contactPhone)) {
      validationErrors.contactPhone = "Please enter a 10 digit phone number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateStreet(siteSettings.address)) {
      validationErrors.address =
        "Address is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes..";
      setErrors(validationErrors);
      return;
    }

    if (!validateGST(siteSettings.gstNumber)) {
      validationErrors.gstNumber = "Please enter a valid GST number.";
      setErrors(validationErrors);
      return;
    }

    if (!siteSettings.gstCharge) {
      validationErrors.gstCharge = "GST Charge is required";
      setErrors(validationErrors);
      return;
    }

    // if (Number(siteSettings.gstCharge) <= 0) {
    //   validationErrors.gstCharge = "GST Charge must be greater than 0";
    //   setErrors(validationErrors);
    //   return;
    // }

    if (!siteSettings.platformFee) {
      validationErrors.platformFee = "Platform Fee is required";
      setErrors(validationErrors);
      return;
    }

    // if (Number(siteSettings.platformFee) <= 0) {
    //   validationErrors.platformFee = "Platform Fee must be greater than 0";
    //   setErrors(validationErrors);
    //   return;
    // }

    if (!siteSettings.deliveryPartnerFee) {
      validationErrors.deliveryPartnerFee = "Delivery Partner Fee is required";
      setErrors(validationErrors);
      return;
    }

    // if (Number(siteSettings.deliveryPartnerFee) <= 0) {
    //   validationErrors.deliveryPartnerFee =
    //     "Delivery Partner Fee must be greater than 0";
    //   setErrors(validationErrors);
    //   return;
    // }

    const formdata = new FormData();

    if (siteSettings.logo) {
      formdata.append("logo", siteSettings.logo);
    }

    if (siteSettings.footerLogo) {
      formdata.append("footer_logo", siteSettings.footerLogo);
    }

    formdata.append("title", siteSettings.title || "");
    formdata.append("description", siteSettings.description || "");
    formdata.append("contact_email", siteSettings.contactEmail || "");
    formdata.append("contact_phone", siteSettings.contactPhone || "");
    formdata.append("address", siteSettings.address || "");

    formdata.append(
      "social_links",
      JSON.stringify({
        facebook: siteSettings.facebook,
        linkdin: siteSettings.linkedin,
      }),
    );
    formdata.append("gst_number", siteSettings.gstNumber || "");
    formdata.append("gst_charge", siteSettings.gstCharge || "");
    formdata.append("platform_fee", siteSettings.platformFee || "");
    formdata.append(
      "delivery_partner_fee",
      siteSettings.deliveryPartnerFee || "",
    );

    fetchUpdateData(urls("updateSiteSettings"), formdata);
  };

  useEffect(() => {
    if (updateSiteSettingsError) {
       console.error("Update error:", updateSiteSettingsError);
    setSnackbarState({ message: "Something went wrong.", status: false });
    setModalOpen(true);
    } else if (
      updateSiteSettingsData &&
      updateSiteSettingsData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateSiteSettingsData["message"],
        status: updateSiteSettingsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      updateSiteSettingsData &&
      updateSiteSettingsData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateSiteSettingsData["message"],
        status: updateSiteSettingsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateSiteSettingsData, updateSiteSettingsError]);

  const handleClose = () => {
    setModalOpen(false);
    clearErrors();
    // initializeSiteSettings();

    if (updateSiteSettingsData?.status === true) {
      fetchData();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: { xs: "calc(100vw - 24px)", md: 1000 },
          maxWidth: "100%",
          p: 3,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h6"
          align="left"
          sx={{ mb: 3, fontWeight: "bold" }}
        >
          Site Settings
        </Typography>

        <TextField
          fullWidth
          label="Title"
          name="title"
          value={siteSettings.title}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.title}
          helperText={errors.title}
        />

        <TextField
          fullWidth
          label="Description"
          name="description"
          value={siteSettings.description}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.description}
          helperText={errors.description}
        />

        {/* LOGO */}

        <Typography mb={1}>Logo</Typography>

        {existingLogo && (
          <Box>
            <img
              src={existingLogo}
              width={120}
              alt="logo"
              style={{ marginBottom: 10 }}
            />

            <br />

            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                setExistingLogo("");

                setSiteSettings({
                  ...siteSettings,
                  logo: null,
                });

                if (logoInputRef.current) {
                  logoInputRef.current.value = "";
                }
              }}
            >
              Delete Logo
            </Button>
          </Box>
        )}

        <br />

        <Button component="label" variant="outlined">
          Upload Logo
          <input
            hidden
            type="file"
            ref={logoInputRef}
            onChange={(e) => handleImageChange(e, "logo")}
          />
        </Button>

        {errors.logo && (
          <Typography color="error" mt={1}>
            {errors.logo}
          </Typography>
        )}

        <br />
        <br />
        <Typography mb={1}>Footer Logo</Typography>

        {existingFooterLogo && (
          <Box>
            <img
              src={existingFooterLogo}
              width={120}
              alt="footer logo"
              style={{ marginBottom: 10 }}
            />

            <br />

            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                setExistingFooterLogo("");

                setSiteSettings({
                  ...siteSettings,
                  footerLogo: null,
                });

                if (footerLogoInputRef.current) {
                  footerLogoInputRef.current.value = "";
                }
              }}
            >
              Delete Footer Logo
            </Button>
          </Box>
        )}

        <br />

        <Button component="label" variant="outlined">
          Upload Footer Logo
          <input
            hidden
            type="file"
            ref={footerLogoInputRef}
            onChange={(e) => handleImageChange(e, "footerLogo")}
          />
        </Button>

        {errors.footerLogo && (
          <Typography color="error" mt={1}>
            {errors.footerLogo}
          </Typography>
        )}

        <br />
        <br />
        <TextField
          fullWidth
          label="Facebook Link"
          name="facebook"
          value={siteSettings.facebook}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.facebook}
          helperText={errors.facebook}
        />

        <TextField
          fullWidth
          label="LinkedIn Link"
          name="linkedin"
          value={siteSettings.linkedin}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.linkedin}
          helperText={errors.linkedin}
        />

        <TextField
          fullWidth
          label="Contact Email"
          name="contactEmail"
          value={siteSettings.contactEmail}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.contactEmail}
          helperText={errors.contactEmail}
        />

        <TextField
          fullWidth
          label="Contact Phone"
          name="contactPhone"
          value={siteSettings.contactPhone}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.contactPhone}
          helperText={errors.contactPhone}
        />

        <TextField
          fullWidth
          label="Address"
          name="address"
          value={siteSettings.address}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.address}
          helperText={errors.address}
        />

        <TextField
          fullWidth
          label="GST Number"
          name="gstNumber"
          value={siteSettings.gstNumber}
          onChange={handleChange}
          sx={{ mb: 2 }}
          error={!!errors.gstNumber}
          helperText={errors.gstNumber}
        />

        <TextField
          fullWidth
          label="GST Charge (%)"
          name="gstCharge"
          value={siteSettings.gstCharge}
          onChange={handleChange}
          sx={{ mb: 2 }}
          type="number"
          error={!!errors.gstCharge}
          helperText={errors.gstCharge}
        />

        <TextField
          fullWidth
          label="Platform Fee"
          name="platformFee"
          value={siteSettings.platformFee}
          onChange={handleChange}
          sx={{ mb: 2 }}
          type="number"
          error={!!errors.platformFee}
          helperText={errors.platformFee}
        />

        <TextField
          fullWidth
          label="Delivery Partner Fee"
          name="deliveryPartnerFee"
          value={siteSettings.deliveryPartnerFee}
          onChange={handleChange}
          sx={{ mb: 3 }}
          type="number"
          error={!!errors.deliveryPartnerFee}
          helperText={errors.deliveryPartnerFee}
        />

        <Box textAlign="center">
          <Button
            variant="contained"
            onClick={submitSiteSettings}
            sx={{ textTransform: "none", width: 120 }}
          >
            Submit
          </Button>
          <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
            <DialogTitle>
              {snackbarState.status === true ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.message}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  alignSelf: "center",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Paper>
    </Box>
  );
};

export default AdminSiteSettings;
